import { render } from "./create-account-form.vue?vue&type=template&id=12d8c15c"
import script from "./create-account-form.vue?vue&type=script&lang=js"
export * from "./create-account-form.vue?vue&type=script&lang=js"

import "./create-account-form.vue?vue&type=style&index=0&id=12d8c15c&lang=scss"

import exportComponent from "C:\\project\\mes_sign\\server\\frontend_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__